/* @flow */
import React from 'react'
import { Translate, setLocale } from 'react-redux-i18n'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import 'react-select/dist/react-select.css'

import './style.css'
import { currencies, langs } from '../../configs/constants'
import { showLogin, logout, search, changeCurrency } from '../../actions/global'
import Divider from '../Divider'
import { AppBar, Toolbar, makeStyles, FormControl, InputLabel, Select, OutlinedInput } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import Badge from '@material-ui/core/Badge';
import AccountCircle from '@material-ui/icons/AccountCircle';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MoreIcon from '@material-ui/icons/MoreVert';

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1,
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}))

const Header = (props) => {
  const classes = useStyles()
  const { currency, routing, className, style } = props
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [state, setState] = React.useState({
    currency: JSON.stringify(currency),
    lang: 'cht',
  });

  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);


  const currencyChanged = event => {
    setState({
      ...state,
      currency: event.target.value,
    });
    const currency = JSON.parse(event.target.value)
    props.changeCurrency(currency)
  };

  const langChanged = event => {
    setState({
      ...state,
      lang: event.target.value,
    })
    props.changeLang(event.target.value)
  }

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  function handleProfileMenuOpen(event) {
    console.log('handleProfileMenuOpen')
    setAnchorEl(event.currentTarget);
  }

  function handleMobileMenuClose() {
    setMobileMoreAnchorEl(null);
  }

  function handleMenuClose() {
    setAnchorEl(null);
    handleMobileMenuClose();
  }

  function handleMobileMenuOpen(event) {
    setMobileMoreAnchorEl(event.currentTarget);
  }

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      { props.user &&
        <MenuItem onClick={() => {
          props.navigate('/account', props.user)
          handleMenuClose()
        }}>Hi, { props.user && (props.user.displayName || props.user.profile.displayName) }</MenuItem>
      }
      { props.user &&
        <MenuItem onClick={() => {
          props.logout()
          handleMenuClose()
        }}><Translate value="logout" /></MenuItem>
      }
      { !props.user &&
        <MenuItem onClick={() => {
          props.showLogin()
          handleMenuClose()
        }}><Translate value="login" /></MenuItem>
      }
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel ref={inputLabel} htmlFor="outlined-currency-native-simple">
            <Translate value="currency" />
          </InputLabel>
          <Select
            value={state.currency}
            onChange={currencyChanged}
            input={
              <OutlinedInput name="currency" labelWidth={labelWidth} id="outlined-currency-native-simple" />
            }
          >
            <MenuItem value="" />
            { currencies.map(currency => <MenuItem key={currency.label} value={JSON.stringify(currency)}>{currency.label}</MenuItem>) }
          </Select>
        </FormControl>
      </MenuItem>
      <MenuItem>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel ref={inputLabel} htmlFor="outlined-language-native-simple">
            <Translate value="language" />
          </InputLabel>
          <Select
            value={state.lang}
            onChange={langChanged}
            input={
              <OutlinedInput name="language" labelWidth={labelWidth} id="outlined-language-native-simple" />
            }
          >
            <MenuItem value="" />
            { langs.map(lang => <MenuItem key={lang.label} value={lang.value}>{lang.label}</MenuItem>) }
          </Select>
        </FormControl>
      </MenuItem>
      { props.user &&
        <MenuItem>
          <IconButton aria-label="Show 11 new notifications" color="inherit">
            <Badge badgeContent={0} color="secondary">
              <NotificationsIcon />
            </Badge>
          </IconButton>
        </MenuItem>
      }
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="Account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
      </MenuItem>
    </Menu>
  );

  if (routing) {
    if (routing.pathname === '/') {
      // classes += ' navbar-float'
    }
  }
  return (
    <div>
      <AppBar className="navbar">
        <Toolbar>
          <div className="logo icon-logo" onClick={() => { props.navigate('/')}}>
            <img src="/logo.svg" alt="intoCaerulus" />
          </div>
          {/* <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ 'aria-label': 'Search' }}
            />
          </div> */}
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <IconButton aria-label="Show 4 new mails" color="inherit">
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel ref={inputLabel} htmlFor="outlined-currency-native-simple">
                  <Translate value="currency" />
                </InputLabel>
                <Select
                  value={state.currency}
                  onChange={currencyChanged}
                  input={
                    <OutlinedInput name="currency" labelWidth={labelWidth} id="outlined-currency-native-simple" />
                  }
                >
                  <MenuItem value="" />
                  { currencies.map(currency => <MenuItem key={currency.label} value={JSON.stringify(currency)}>{currency.label}</MenuItem>) }
                </Select>
              </FormControl>
            </IconButton>
            <IconButton>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel ref={inputLabel} htmlFor="outlined-language-native-simple">
                  <Translate value="language" />
                </InputLabel>
                <Select
                  value={state.lang}
                  onChange={langChanged}
                  input={
                    <OutlinedInput name="language" labelWidth={labelWidth} id="outlined-language-native-simple" />
                  }
                >
                  { langs.map(lang => <MenuItem key={lang.label} value={lang.value}>{lang.label}</MenuItem>) }
                </Select>
              </FormControl>
            </IconButton>
            { props.user &&
              <IconButton aria-label="Show 17 new notifications" color="inherit">
                <Badge badgeContent={0} color="secondary">
                  <NotificationsIcon />
                </Badge>
              </IconButton>
            }
            <IconButton
              edge="end"
              aria-label="Account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="Show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </div>
        {/* { searchInputs } */}
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </div>
  )
}

const mapStateToProps = state => {
  return {
    locale: state.i18n.locale,
    routing: state.router.location,
    user: state.global.user,
    locations: state.scene.locations,
    currency: state.global.currency,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showLogin: () => dispatch(showLogin()),
    logout: () => dispatch(logout()),
    changeLang: (lang) => dispatch(setLocale(lang)),
    changeCurrency: (currency) => dispatch(changeCurrency(currency)),
    navigate: (location) => dispatch(push(location)),
    search: (keyword) => dispatch(search(keyword)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)


// WEBPACK FOOTER //
// ./src/components/Navbar/index.js